// libs
import { css } from "@emotion/core";
import styled from "@emotion/styled";

// components
import BaseTitle from "./components/Title";

// constants
import { BREAKPOINTS, FONTS } from "shared/styles/base";

export const AuthContainer = styled.div`
    display: flex;
    justify-content: center;
    font-family: ${FONTS.CERA};

    @media screen and (max-width: ${BREAKPOINTS.MOBILE}px) {
        flex-direction: column-reverse;
    }
`;

export const Title = styled(BaseTitle)`
    margin-top: 15px;
    margin-bottom: 0;
`;

export const modalCss = css`
    width: 944px;
    min-height: 550px;
    border-radius: 2px;
    padding-bottom: 30px;

    @media screen and (max-width: ${BREAKPOINTS.MOBILE}px) {
        width: 100%;
        height: 100%;
        max-width: 100%;
        min-height: 100%;
        padding: 20px;
        border: none;
    }
`;
